import { jsx as C } from "react/jsx-runtime";
const r = ({
  width: t,
  height: o,
  className: n
}) => /* @__PURE__ */ C(
  "svg",
  {
    className: n,
    fill: "none",
    height: o,
    viewBox: "0 0 20 18",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ C("g", { id: "State=shortlisted", children: /* @__PURE__ */ C(
      "path",
      {
        d: "M8.72408 1.20554C8.04119 0.884489 7.29615 0.717327 6.54155 0.715881C6.1866 0.717027 5.83271 0.754894 5.48555 0.82888C4.54057 0.99056 3.65823 1.40903 2.93511 2.0385C2.21198 2.66797 1.67592 3.48419 1.38555 4.39788C1.02341 5.37276 0.90392 6.42112 1.03737 7.45249C1.17082 8.48386 1.5532 9.46728 2.15154 10.3179C2.79669 11.2962 3.57026 12.1834 4.45153 12.9559C5.68277 14.0569 6.94548 15.1515 8.17735 16.2193C8.31717 16.3405 8.4566 16.4614 8.59554 16.5819L9.41854 17.2949C9.56506 17.4343 9.73761 17.5436 9.92635 17.6163C10.1151 17.6891 10.3163 17.7239 10.5185 17.7189C10.9209 17.7095 11.3041 17.5446 11.5875 17.2589C12.8515 16.1729 14.1325 15.0669 15.3955 13.9729C16.5225 13.0391 17.5463 11.9874 18.4495 10.8359C19.0639 10.0533 19.5114 9.15308 19.7645 8.19088V8.18089C19.8267 7.92731 19.8674 7.67276 19.9069 7.42588L19.9085 7.41589C19.913 7.38806 19.9174 7.35996 19.9218 7.33183C19.9341 7.25282 19.9465 7.17363 19.9605 7.09988L19.9686 7.05688V6.15089C19.9636 6.10589 19.9555 6.05688 19.9515 6.03288C19.9505 6.02676 19.9494 6.0207 19.9484 6.01484C19.9453 5.99773 19.9426 5.98231 19.9426 5.97189C19.8469 4.92767 19.4888 3.92458 18.9015 3.05589C18.4092 2.33631 17.7487 1.74766 16.9775 1.34095C16.2063 0.934243 15.3475 0.721753 14.4755 0.721886C14.0717 0.722315 13.6691 0.768265 13.2755 0.858879H13.2656C12.1873 1.13227 11.2195 1.73108 10.4935 2.57388C10.011 1.99371 9.40697 1.5266 8.72408 1.20554Z",
        fill: "currentColor",
        id: "Union"
      }
    ) })
  }
);
export {
  r as Content
};
